export default __webpack_public_path__ + "static/media/title.9043b778.svg";